"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _commonReact = require("@devsta/common-react");

var _Clip = _interopRequireDefault(require("../components/Clip"));

var _PlayerContext = _interopRequireDefault(require("../../../../../contexts/PlayerContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DRAG_TYPE = 'box';

function endDrag(_ref, monitor) {
  var clip = _ref.clip;
  var dropResult = monitor.getDropResult();

  if (dropResult) {
    var onClipDrop = dropResult.onClipDrop,
        xPos = dropResult.xPos;
    onClipDrop(clip, {
      xPos: xPos
    });
  }
}

function beginDrag(_ref2) {
  var clip = _ref2.clip;
  return {
    clipId: clip.clipId
  };
}

function getDragConfig(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

var dragHandlers = {
  beginDrag: beginDrag,
  endDrag: endDrag
};
var dragSource = (0, _reactDnd.DragSource)(DRAG_TYPE, dragHandlers, getDragConfig);

function Clip(_ref3) {
  var canUpdateVideo = _ref3.canUpdateVideo,
      clip = _ref3.clip,
      props = _objectWithoutProperties(_ref3, ["canUpdateVideo", "clip"]);

  return /*#__PURE__*/_react.default.createElement(_PlayerContext.default.Consumer, null, function (_ref4) {
    var timelineZoomSeconds = _ref4.timelineZoomSeconds;
    return /*#__PURE__*/_react.default.createElement(_commonReact.CommentsConsumer, null, function (_ref5) {
      var _ref5$actions = _ref5.actions,
          deleteComment = _ref5$actions.deleteComment,
          getOrderedComments = _ref5$actions.getOrderedComments;
      return /*#__PURE__*/_react.default.createElement(_Clip.default, _extends({
        canUpdateVideo: canUpdateVideo,
        clip: clip,
        timelineZoomSeconds: timelineZoomSeconds,
        comments: getOrderedComments(clip.clipId),
        deleteComment: deleteComment
      }, props));
    });
  });
}

var _default = dragSource(Clip);

exports.default = _default;